import React from "react";
import "./style.css";

function Footer() {
  return (
    <footer className="footer">
        <p className="footer-text">Made with ❤️ by Ashutosh Gupta</p>
        <a 
          href="https://www.linkedin.com/in/ashutosh-gupta-198380261/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="linkedin-link"
        >
          Connect on LinkedIn
        </a>
    </footer>
  );
}

export default Footer;


